import { SortModel } from "@/context/table";

type NumberKeys = "lastLogin";
type StringKeys = "oid" | "bid";
type ObjectKeys = "sortModel";
type BooleanKeys = "hasMultipleOrgs";

type Keys = StringKeys | NumberKeys | ObjectKeys | BooleanKeys;

function getItem(key: NumberKeys): number | undefined;
function getItem(key: StringKeys): string | undefined;
function getItem(key: ObjectKeys): SortModel | undefined;
function getItem(key: BooleanKeys): boolean | undefined;

function getItem<D>(key: Keys): D | undefined {
    const value = localStorage.getItem(key);

    if (!value) return undefined;
    return JSON.parse(value);
}

function setItem(key: StringKeys, value: string): void;
function setItem(key: NumberKeys, value: number): void;
function setItem(key: ObjectKeys, value: SortModel): void;
function setItem(key: BooleanKeys, value: boolean): void;

function setItem<D>(key: Keys, value: D) {
    localStorage.setItem(key, JSON.stringify(value));
}

function removeItem(key: Keys) {
    localStorage.removeItem(key);
}

function clear() {
    localStorage.clear();
}

export default {
    getItem,
    setItem,
    removeItem,
    clear,
};
